import common from '@page/common/js/common';
import useFreeLayout from '@global/composable/useFreeLayout';
import $ from 'jquery';

const { initSlick, transitionEffects } = useFreeLayout();

function HomeContent() {
  $(window).scroll();
  $('.main').css({ visibility: 'visible' }).addClass('js-loaded');
  $('.home-loading').fadeOut();
}

HomeContent();

initSlick();
transitionEffects();

$(document).ready(() => {
  const $header = $('#page-home .header');
  const b = $header.height();

  if ($header.length < 1) return;

  $(window).scroll(() => {
    if ($(window).scrollTop() > b) {
      $header.addClass('active');
    } else {
      $header.removeClass('active');
    }
  });
});
